import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Container, FormFeedback, Input, Label, Form } from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
// action
import { userForgetPassword } from "../../store/actions";
// import images
import logo from "../../assets/images/logo-sm.svg";
import CarouselPage from "../AuthenticationInner/CarouselPage";
import { getConfiguration } from '../../helpers/backend_helper';

const ForgetPasswordPage = (history) => {

  const [configuration, setConfiguration] = useState({image:'',name:''})
  useEffect(() => {
      /*getConfiguration().then(response => {
        if(response.status){
          setConfiguration(response.configuration)  
        }
      })*/
  }, [])

  document.title = "Olvide mi contraseña";

  const dispatch = useDispatch()

  const { forgetError, forgetSuccessMsg } = useSelector(state => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }))

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Intresa tu Correo electrónico"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, history));
    }
  });

  return (
    <React.Fragment>
      <div className="auth-page">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4} md={5} className="col-xxl-3">
              <div className="auth-full-page-content d-flex p-sm-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5 text-center">
                      <Link to="/dashboard" className="d-block auth-logo">
                         <img src={configuration.url ? configuration.url:'logo'} alt="" height="28" /> <span className="logo-txt">{configuration.name ? configuration.name:''}</span>
                      </Link>
                    </div>
                    <div className="auth-content my-auto">
                      {forgetError && forgetError ? (
                        <Alert color="danger" style={{ marginTop: "13px" }}>
                          {forgetError}
                        </Alert>
                      ) : null}
                      {forgetSuccessMsg ? (
                        <Alert color="success" style={{ marginTop: "13px" }}>
                          {forgetSuccessMsg}
                        </Alert>
                      ) : null}
                      {!forgetSuccessMsg ? 
                      <Form
                        className="custom-form mt-4"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">

                          <Label className="form-label">Correo electrónico</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Ingresa Correo electrónico"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email && validation.errors.email ? true : false
                            }
                          />
                          {validation.touched.email && validation.errors.email ? (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          ) : null}

                        </div>

                        <Row className="mb-3">
                          <Col className="text-end">
                            <button
                              className="btn btn-primary w-100 waves-effect waves-light"
                              type="submit"
                            >
                              Reset
                            </button>
                          </Col>
                        </Row>

                      </Form>
                      :
                       <Link to={`/login`}
                        className="btn btn-primary w-100 waves-effect waves-light"
                        >
                          Volver
                        </Link>
                      }

                      <div className="mt-5 text-center">
                        <p className="text-muted mb-0">¿ Ya recordaste tu contraseña?  <Link to="/login" className="">Iniciar sesión</Link> </p>
                      </div>
                    </div>
                    <div className="mt-4 mt-md-5 text-center">
                      <p className="mb-0">© {new Date().getFullYear()} {configuration.name ? configuration.name:''} </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <CarouselPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default ForgetPasswordPage;